/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { NumberInput } from '../../../../../components/inputs/NumberInput';
import { FormSelect } from '../../../../../components/tables/filterForms/FormSelect';
import { useGetAllInvoicesQuery } from '../../../../../services/endpoints/finance/invoice';
import { Invoice } from '../../../../../types/finance.types';
import { StepProps } from './AddEditPayment';

export const PaymentForm = ({
  touched,
  errors,
  remainingBalance,
  maxPaymentAmount,
  readOnly
}: StepProps) => {
  const { data: invoices, error: invoicesError } = useGetAllInvoicesQuery();

  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Payment Details" showRequiredLegend={!readOnly} />
        </Col>
      </Row>
      <Row>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="invoice_id"
          >
            <Field
              as={FormSelect}
              name="invoice_id"
              id="invoice_id"
              label="Invoice Name"
              options={
                invoices?.results?.map((c: Invoice) => ({ id: c.id ?? 1, label: c.name ?? '' })) ??
                []
              }
              loadingError={invoicesError ? 'Error loading invoices' : undefined}
            />
          </Form.Group>
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="payment_method"
          >
            <FormLabel required>Payment Method</FormLabel>
            <Field
              as={Form.Select}
              name="payment_method"
              aria-required
            >
              <option key="select"></option>
              <option
                key="check"
                value="check"
              >
                Check
              </option>
              <option
                key="ach"
                value="ach"
              >
                ACH
              </option>
            </Field>
            {touched.payment_method && errors.payment_method && (
              <div className="text-danger">{String(errors.payment_method)}</div>
            )}
          </Form.Group>
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="check_number"
          >
            <FormLabel>Check Number</FormLabel>
            <Field
              name="check_number"
              as={Form.Control}
              isInvalid={touched.check_number && !!errors.check_number}
            />
            <ErrorMessage name="check_number">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="total"
          >
            <FormLabel required>Amount ($)</FormLabel>
            <Field
              name="total"
              as={NumberInput}
              min={0.01}
              max={maxPaymentAmount > 0 ? maxPaymentAmount : undefined}
              step="0.01"
              isInvalid={touched.total && !!errors.total}
              disabled={maxPaymentAmount <= 0}
              aria-required
            />
            <Form.Text>
              The remaining balance on this invoice is ${remainingBalance.toFixed(2)}.{' '}
              {remainingBalance === 0 ? 'No additional payment can be made.' : ''}
            </Form.Text>
            <ErrorMessage name="total">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="notes"
          >
            <FormLabel htmlFor="notes">Payment Notes</FormLabel>
            <Field
              name="notes"
              as="textarea"
              className="form-control"
              rows={4}
              isInvalid={touched.notes && !!errors.notes}
            />
            <Form.Text>The payment date will be {new Date().toLocaleDateString()}</Form.Text>
            <ErrorMessage name="notes">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
